import React, { memo } from 'react';
import MultiSelectSearch from '../../../components/MultiSelectSearch/MultiSelectSearch';
import FilterUtils from '../../../utils/FilterUtils';

const FiltersSection = ({ filterOptions, filters, updateFilters, isDisabled = false }) => {
	const handleMultiSelectChange = (_options, fieldName) => {
		// Update the state with the new options and filters
		const { updatedOptions, updatedFilters } = FilterUtils.handleMultiSelectChange(
			_options,
			fieldName,
			filterOptions,
			filters
		);
		updateFilters(updatedOptions, updatedFilters);
	};

	return (
		<>
			{filterOptions.states && (
				<MultiSelectSearch
					label="State"
					disabled={isDisabled}
					options={filterOptions.states}
					onApply={(options) => handleMultiSelectChange(options, 'states')}
				/>
			)}
			<MultiSelectSearch
				label="Facilities"
				disabled={isDisabled}
				options={filterOptions.facilities}
				onApply={(options) => handleMultiSelectChange(options, 'facilities')}
			/>
			<MultiSelectSearch
				label="Shift type"
				disabled={isDisabled}
				options={filterOptions.shiftTypes}
				onApply={(options) => handleMultiSelectChange(options, 'shiftTypes')}
			/>
			<div className="right-align-dropdown">
				<MultiSelectSearch
					label="Start time"
					disabled={isDisabled}
					options={filterOptions.startTimes}
					onApply={(options) => handleMultiSelectChange(options, 'startTimes')}
				/>
			</div>
		</>
	);
};

export default memo(FiltersSection);
